import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

export default function RcFather() {

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const [rcno, setRcno] = useState("");
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadHistory = async () => {
    try {
      const res = await fetch(
        `https://rcfinder.online/api/get_rc_father_list.php?user_id=${user.id}`
      );
      const data = await res.json();
      if (data.list) setHistory(data.list);
    } catch {}
  };

  useEffect(() => {
    if (user?.id) loadHistory();
  }, []);

  const handleSearch = async () => {

    if (!rcno) return Swal.fire("Enter RC Number");

    setLoading(true);

    try {
      const res = await fetch("https://rcfinder.online/api/rc_to_father.php", {
        method: "POST",
        headers: {"Content-Type":"application/json"},
        body: JSON.stringify({
          user_id: user.id,
          rcno
        })
      });

      const data = await res.json();

      if (data.status === "wallet_low") {
        Swal.fire("Wallet Low", "Recharge first", "warning");
      }
      else if (data.status === "failed") {
        Swal.fire("Not Found ❌", data.message, "error");
      }
      else if (data.status === "success") {

        await Swal.fire({
          icon: "success",
          title: data.duplicate ? "Already Exists" : "Success 🎉",
          html: `
            <b>RC:</b> ${data.rcno}<br>
            <b>Name:</b> ${data.full_name}<br>
            <b>Father:</b> ${data.relation_name}
          `
        });

        setRcno("");
        loadHistory();
      }

    } catch {
      Swal.fire("Server Error");
    }

    setLoading(false);
  };

  return (
    <div style={{padding:"20px"}}>

      <h2>RC → Father Name</h2>
      <p style={{color:"green"}}>₹50 per success</p>

      <input
        value={rcno}
        onChange={(e)=>setRcno(e.target.value.toUpperCase())}
        placeholder="Enter RC Number"
      />

      <button onClick={handleSearch}>
        {loading ? "Please wait..." : "Get Father Name (50/-)"}
      </button>

      <h3>History</h3>

      <table border="1">
        <thead>
          <tr>
            <th>RC</th>
            <th>Name</th>
            <th>Father</th>
            <th>Date</th>
          </tr>
        </thead>

        <tbody>
          {history.map((h,i)=>(
            <tr key={i}>
              <td>{h.rcno}</td>
              <td>{h.full_name}</td>
              <td>{h.relation_name}</td>
              <td>{h.created_at}</td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
}